import { useParams } from 'react-router-dom'
import { makeCoreGetRequest } from 'utils/api'
import { useNotification } from 'hooks'
import { formatErrorMessage } from 'utils/formatting'
import { BasicTable } from '@fullscreendigital/carrefour-dex-fe'
import { useQuery } from 'react-query'
import { columns } from './helpers'
import s from '../../../../../commonStyles.modules.scss'
import { TableContainer } from "@mui/material";

const ReceptionStatus = ({ isHistorical }) => {
  const { showNotification } = useNotification()
  const { id } = useParams()

  const shopCode = new URLSearchParams(location.search).get('shopCode')

  const { data } = useQuery(
    ['truck-status', id],
    async () => {
      if (id) {
        const result = await makeCoreGetRequest(
          isHistorical
            ? `/shop-reception/truckArchive/details/${id}?tab=traceability_reception&shopCode=${shopCode}`
            : `/shop-reception/truck/details/${id}?tab=traceability_reception&shopCode=${shopCode}`
        )
        return result
      }
      return null
    },
    {
      onError: error => {
        showNotification({
          message: `A apărut o eroare la obtinerea datelor din tabel. ${formatErrorMessage(error)}`,
          type: 'error'
        })
      }
    }
  )

  return (
    <TableContainer style={{ marginTop: 15, maxHeight: 600 }}>
      <BasicTable
        columns={columns}
        rows={data?.traceabilityReceptionTruckModelsList || []}
        containerProps={{
          className: s.table
        }}
      />
    </TableContainer>
  )
}

export default ReceptionStatus
